import React, { useEffect, useState } from "react";
import Collapse from "@mui/material/Collapse";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DemoParinted from "../../../../../templates/ApplicationDetails/components/RichTextArea";
import { Button, Container, Row } from "react-bootstrap";

const CollapsibleAdditionalRemarks = ({ formData, additionalComment, setAdditionalComment, handleSubmit }) => {
  const [open, setOpen] = useState(false);
  const applicationStatus = formData?.status;

  useEffect(() => {
    if (
      (formData?.mapSubDetails && formData?.mapSubDetails?.formattedAdditionalComment) ||
      (formData?.additionalComment && formData?.additionalComment?.trim()?.length !== 0)
    ) {
      setAdditionalComment(formData?.mapSubDetails?.formattedAdditionalComment || formData?.additionalComment);
    }
  }, [formData?.additionalComment]);

  return (
    <div
      style={{
        margin: "15px 0",
        width: "100%",
      }}
    >
      {/* Header */}
      <div
        onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
        style={{
          background: "rgba(52, 73, 94, 0.94)",
          padding: "10px 20px",
          borderRadius: "4px",
          fontWeight: 600,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          width: "100%",
        }}
      >
        <span
          style={{
            color: "#fff",
            fontSize: "16px",
          }}
        >
          Additional Comment (If any)
        </span>

        {open ? <RemoveIcon sx={{ color: "#fff" }} /> : <AddIcon sx={{ color: "#fff" }} />}
      </div>

      {/* Body */}
      <Collapse in={open}>
        <div
          id="example-collapse-text"
          style={{
            width: "100%",
            marginTop: "12px",
            padding: "12px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              border: "2px solid grey",
              padding: "10px",
            }}
          >
            <DemoParinted setContent={setAdditionalComment} content={additionalComment} useNewSanitized={true} />

            <Button
              style={{
                marginTop: "15px",
                color: "#fff",
                backgroundColor: applicationStatus === "APPROVED" ? "grey" : "rgb(31, 74, 124)",
                minWidth: "100px",
              }}
              onClick={handleSubmit}
              disabled={applicationStatus === "APPROVED"}
            >
              Save
            </Button>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default CollapsibleAdditionalRemarks;
